import {
  ApiRequest,
  GetBaseServiceFunctions,
  queryClient,
} from '../baseService'

const BaseRoute = 'app/companies'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function Enable(id) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.put(`${BaseRoute}/${id}/enable`)
}

function Disable(id) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.put(`${BaseRoute}/${id}/disable`)
}

function GetBusinessUnits(companyId, params = {}) {
  return ApiRequest.get(`${BaseRoute}/${companyId}/businessUnits`, {
    params,
  })
}

function GetBookingHistory(params = {}) {
  return ApiRequest.get(`${BaseRoute}/bookingHistory`, {
    params,
  })
}

function GetServiceBookingHistory(params = {}) {
  return ApiRequest.get(`${BaseRoute}/serviceBookingHistory`, {
    params,
  })
}

function CreateBusinessUnit(companyId, data) {
  queryClient.invalidateQueries([BaseRoute, companyId])
  return ApiRequest.post(`${BaseRoute}/${companyId}/businessUnits`, data)
}

function UpdateBusinessUnit(companyId, businessUnitId, data) {
  queryClient.invalidateQueries([BaseRoute, companyId])
  return ApiRequest.put(
    `${BaseRoute}/${companyId}/businessUnits/${businessUnitId}`,
    data
  )
}

function DeleteBusinessUnit(companyId, businessUnitId) {
  queryClient.invalidateQueries([BaseRoute, companyId])
  return ApiRequest.delete(
    `${BaseRoute}/${companyId}/businessUnits/${businessUnitId}`
  )
}

function CheckDuplicate(params) {
  return ApiRequest.get(`${BaseRoute}/isDupplicateName`, { params })
}

function GetSimilarItemsByName(params) {
  return ApiRequest.get(`${BaseRoute}/similarItemsByName`, { params })
}

function GetFavouriteSpecialists(id, params) {
  return ApiRequest.get(`${BaseRoute}/${id}/favourite-specialists`, { params })
}

function AddFavouriteSpecialists(id, specialistId) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.post(`${BaseRoute}/${id}/favourite-specialists`, {
    specialistId,
  })
}
function DeleteFavouriteSpecialists(id, specialistId) {
  queryClient.invalidateQueries([BaseRoute, id])
  return ApiRequest.delete(
    `${BaseRoute}/${id}/favourite-specialists/${specialistId}`
  )
}
function ExportSearchResult(payload = {}) {
  return ApiRequest.post(`${BaseRoute}/export`, payload, {
    responseType: 'arraybuffer',
  })
}
function DownloadUploadCompanyTemplate() {
  return ApiRequest.post(
    `${BaseRoute}/template-import`,
    {},
    { responseType: 'arraybuffer' }
  )
}
function UploadFiles(file) {
  return ApiRequest.post(`${BaseRoute}/import`, file)
}

function CompanyPMSConnect(companyPMSId) {
  return ApiRequest.get(`${BaseRoute}/${companyPMSId}/pms-config-authorize`)
}

function GetPMSConfig(companyId) {
  return ApiRequest.get(`${BaseRoute}/${companyId}/pms-config`)
}
function SavePMSConfig(companyId, data) {
  queryClient.invalidateQueries([BaseRoute, companyId])
  return ApiRequest.post(`${BaseRoute}/${companyId}/pms-config`, data)
}

function UpdateSyncAsync(payload) {
  return ApiRequest.post(
    `${BaseRoute}/pms-matter-sync?thirdPartySource=${payload.thirdPartySource}&thirdPartySourceId=${payload.thirdPartySourceId}`
  )
}

function UpdateSyncMatterNo(payload) {
  return ApiRequest.post(
    `${BaseRoute}/${payload.companyPMSId}/pms-matter-sync?thirdPartySource=${payload.thirdPartySource}&matterNo=${payload.matterNo}`
  )
}

function PMSSendRequest(companyPMSId, data) {
  queryClient.invalidateQueries([BaseRoute, companyPMSId])
  return ApiRequest.post(`${BaseRoute}/${companyPMSId}/pms-send-request`, data)
}

function GetBookingAgents(companyId) {
  return ApiRequest.get(`${BaseRoute}/${companyId}/booking-agents`)
}

function UpdateBookingAgents(companyId, data) {
  return ApiRequest.put(`${BaseRoute}/${companyId}/booking-agents`, data)
}

function NotifyProviderReportMonthly(companyId) {
  return ApiRequest.post(
    `${BaseRoute}/${companyId}/notify-provider-report-monthly`
  )
}

const API = {
  ...baseFunctions,
  Enable,
  Disable,
  GetBusinessUnits,
  CreateBusinessUnit,
  UpdateBusinessUnit,
  DeleteBusinessUnit,
  GetBookingHistory,
  getSimilarItems: CheckDuplicate,
  GetFavouriteSpecialists,
  AddFavouriteSpecialists,
  DeleteFavouriteSpecialists,
  GetSimilarItemsByName,
  ExportSearchResult,
  DownloadUploadCompanyTemplate,
  UploadFiles,
  GetPMSConfig,
  SavePMSConfig,
  CompanyPMSConnect,
  PMSSendRequest,
  GetBookingAgents,
  GetServiceBookingHistory,
  UpdateBookingAgents,
  NotifyProviderReportMonthly,
  UpdateSyncAsync,
  UpdateSyncMatterNo,
}

export default API
